import { Role } from '../utils/Enums/Roles';
import { faEnvelope, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { CustomButton } from './CustomButton';

export const EmailActionComponent = ({
    onAction,
    accessActionRoles,
    disabled,
    hasEmailError,
}: {
    onAction: () => void;
    accessActionRoles?: Role[];
    disabled?: boolean;
    hasEmailError?: boolean;
}) => {
    const { hasPermission } = useContext(AuthContext);
    const isForbidden = (accessActionRoles && !hasPermission([...accessActionRoles, Role.ADMIN])) || disabled;

    return (
        <span
            className='position-relative d-inline-flex align-items-center'
            title={hasEmailError ? 'Грешка при изпращане: невалиден или отхвърлен имейл адрес' : undefined}
        >
            <CustomButton
                icon={faEnvelope}
                iconClass='fa-fw'
                onClick={() => onAction()}
                className={`me-1 color-main ${hasEmailError ? 'text-danger' : ''}`}
                disabled={isForbidden}
            />
            {hasEmailError && (
                <FontAwesomeIcon
                    icon={faExclamationCircle}
                    className='text-danger position-absolute'
                    style={{
                        top: -4,
                        right: 2,
                        fontSize: '0.75rem',
                        backgroundColor: '#ffffff',
                        borderRadius: '50%',
                        pointerEvents: 'none',
                    }}
                />
            )}
        </span>
    );
};
